<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-area" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">按类型就业情况</span>
          <div class="decoration2">
            <dv-decoration-2 :reverse="true" style="width:5px;height:6rem;" />
          </div>
        </div>
      </div>
      <div style="width:100%;height:240px;display: flex;
    justify-content: space-around;">
        <!-- <BottomRightChart /> -->
        <LeiDaThree id="three" v-for="(item,index) in jiuyeData" :key="index"
        :juData="item" :chartId="index" style="width:32%;height:240px"></LeiDaThree>
      </div>
      <div style="width:100%;height:230px">
        <div id="linetothree" style="width:100%;height:100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import BottomRightChart from "@/components/echart/bottom/bottomRightChart";
import LeiDaThree from "./leidathree";

import * as echarts from "echarts"

export default {
  components: {
    LeiDaThree
  },
  data() {
    return {
      jiuyeData: [
        {
          name: "帮扶就业",
          data: [100,75,100,83],
          color:"#43dfa2",
        },
        {
          name: "城市公共服务岗位",
          data: [50,100,30,100],
          color:"#D9D562",
        },
        {
          name: "灵活就业",
          data: [40,75,82,93],
          color:"#0C89B0",
        },
      ],
      colorList: {
        linearYtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#f5b44d",
            },
            {
              offset: 1,
              color: "#28f8de",
            },
          ],
        },
        linearGtoB: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#43dfa2",
            },
            {
              offset: 1,
              color: "#28f8de",
            },
          ],
        },
        linearBtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#1c98e8",
            },
            {
              offset: 1,
              color: "#28f8de",
            },
          ],
        },
        areaBtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(35,184,210,.2)",
            },
            {
              offset: 1,
              color: "rgba(35,184,210,0)",
            },
          ],
        },
      },
    }
  },
  mounted() {
    this.lineThree()
  },
  methods: {
    lineThree() {
      var chartDom = document.getElementById("linetothree")
      var myChart = echarts.init(chartDom)
      var xdata = [
        "2020.6",
        "2020.7",
        "2020.8",
        "2020.9",
        "2020.10",
        "2020.11",
        "2020.12",
        "2021.1",
        "2021.2",
        "2021.3",
        "2021.4",
        "2021.5",
        "2021.6",
        "2021.7",
        "2021.8",
        "2021.9",
        "2021.10",
        "2021.11",
      ]

      var ydata = [
        530,
        877,
        1246,
        1549,
        1802,
        2098,
        2356,
        2586,
        2697,
        2987,
        3626,
        4447,
        5023,
        5470,
        5859,
        6337,
        6926,
        7234,
      ]
      var option = {
        title: {
          text: "",
        },
        legend: {},
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "8%",
          right: "5%",
          bottom: "18%",
          top: "16%",
        },
        xAxis: {
          type: "category",
          position: "bottom",
          axisLine: true,
          axisLabel: {
            color: "rgba(255,255,255,.8)",
            fontSize: 12,
          },
          data: xdata,
        },
        // 下方Y轴
        yAxis: {
          name: "就业人数",
          nameLocation: "end",
          nameGap: 24,
          nameTextStyle: {
            color: "rgba(255,255,255,.5)",
            fontSize: 14,
          },
          splitNumber: 4,
          axisLine: {
            lineStyle: {
              opacity: 0,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#fff",
              opacity: 0.1,
            },
          },
          axisLabel: {
            color: "rgba(255,255,255,.8)",
            fontSize: 12,
          },
        },
        series: [
          {
            name: "",
            type: "line",
            smooth: true,
            symbol: "emptyCircle",
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#fff",
              },
            },
            lineStyle: {
              normal: {
                color: this.colorList.linearBtoG,
                width: 3,
              },
            },
            areaStyle: {
              normal: {
                color: this.colorList.areaBtoG,
              },
            },
            data: ydata,
            lineSmooth: true,
            tooltip: {
              position: "top",
              formatter: "{c}",
              backgroundColor: "rgba(28,152,232,.2)",
              padding: 6,
            },
          },
        ],
      }
      myChart.setOption(option)
      window.addEventListener("resize", function() {
        myChart.resize() //下面可以接多个图
      })
    },
  },
}
</script>

<style lang="scss" class>
$box-height: 520px;
$box-width: 100%;
#bottomRight {
  padding: 14px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  //下滑线动态
  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }
  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;
    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>
